<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel">
      <h3 slot="header" class="modal-header">添加账户</h3>
      <Form :label-width="120" ref="formData" :rules="formRules" :model="formData" :inline="true">
        <FormItem label="项目名称"  prop="projectFid">
          <Select class="formwidth"  v-model="formData.projectFid">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value"
                    :key="'keyA'+index">{{item.text}}</Option>
          </Select>
        </FormItem>
        <FormItem label="银行名称" prop="bankName">
          <Input class="formwidth" v-model="formData.bankName"/>
        </FormItem>
        <FormItem label="账户" prop="accountNo">
          <Input class="formwidth" v-model="formData.accountNo"/>
        </FormItem>
        <FormItem label="POS终端号" prop="terminalNo">
          <Input class="formwidth" v-model="formData.terminalNo"/>
        </FormItem>
        <FormItem label="参考号位数" prop="referenceNum">
          <Input class="formwidth" v-model="formData.referenceNum"/>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import {addPos} from "../../../../api/accountConfig";

  export default {
    // name: "addcount"   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      projectList:{
        type:Array,
        default:()=>{return []}
      }
    },
    watch:{
      n(){
        this.$refs['formData'].resetFields()
        this.isShow=true
      }
    },
    data(){
      return {
        loading: true,
        isShow:false,
        formData:{
          "accountNo": "",
          "bankName": "",
          "fid": "",
          "projectFid": "",
          "projectName": "",
          "referenceNum": "",
          "terminalNo": ""
        },
        formRules :{
            "accountNo":[
              {required: true, message: '请输入账户', trigger: 'blur', type: 'string'}
            ],
            "bankName": [
              {required: true, message: '请输入银行名称', trigger: 'blur', type: 'string'}
            ],
            "projectFid": [
              {required: true, message: '请选择项目', trigger: 'change', type: 'string'}
            ]
        }

      }
    },
    computed: {

    },
    methods:{
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      addPos(){
        addPos(this.formData).then(res=>{
          this.$Message.success('添加账户成功')
          this.$emit('done')
          this.isShow=false
        }).catch(error=>{
          this.changeLoading()
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        this.$refs['formData'].validate(bool=>{
          if(bool){
            let f1=Boolean(this.formData.terminalNo || this.formData.terminalNo===0)   //pos终端号是否存下
            let f2=Boolean(this.formData.referenceNum || this.formData.referenceNum===0)  // 参考号尾数是否存在
            if(f1 ===f2){
              this.addPos()
            }
            else {
              this.$Message.info('pos终端号与参考号位数需同时存在')
              this.changeLoading()
            }
          }
          else {
            this.changeLoading()
          }
        })
      },
      cancel(){
      }
    },
  }
</script>

<style scoped>
  .formwidth{
    width: 250px;
  }

</style>
